"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.014 2.895c0-.167 0-.289-.116-.404L15.447 1.04h6.069v6.069l-1.45-1.451a.519.519 0 0 0-.365-.155h-.002a.517.517 0 0 0-.364.155L13 11.992l-.034.037v.051c0 .02-.021.082-.034.119a.655.655 0 0 0-.046.197v10.565H9.174l-.077-12.254L16.82 3.3c.085-.088.194-.195.194-.405Zm-8.353 6.8L2.654 3.687l2.438-2.438 6.06 6.06-2.49 2.386ZM22.116 0h-7.918c-.31 0-.42.133-.507.38-.11.153-.006.437.101.544l1.97 1.969-3.864 3.703-6.48-6.48-.033-.023c-.19-.095-.49-.105-.697.102L1.521 3.362a.504.504 0 0 0 0 .729l6.614 6.615v12.775c0 .306.214.519.52.519h4.752c.206 0 .483-.183.585-.385l.012-10.93 5.816-5.814 1.97 1.971c.123.122.338.204.538.102a.558.558 0 0 0 .306-.507V.52a.497.497 0 0 0-.518-.52Z",
    clipRule: "evenodd"
  })]
});